import LeilaoDeVeiculos from '../components/templates/LeilaoDeVeiculos';

export default function LeilaoDeVeiculosPage() {
  return <LeilaoDeVeiculos />;
}
